import React from 'react';
import { Seo } from '../components/Seo';

const Block = ({ title, children }) => (
  <section className="mb-10">
    <h2 className="text-xl md:text-2xl font-bold text-slate-900 mb-3">{title}</h2>
    <div className="text-slate-600 leading-relaxed space-y-2">{children}</div>
  </section>
);

const PolitiqueConfidentialite = () => {
  return (
    <main className="pt-28" data-testid="page-politique-confidentialite">
      <Seo
        title="Politique de confidentialité | VIREO Rénovation"
        description="Politique de confidentialité et traitement des données personnelles du site VIREO Rénovation (RGPD)."
        path="/politique-confidentialite"
      />
      <section className="bg-slate-900 py-14 md:py-16">
        <div className="container mx-auto px-4">
          <span className="text-emerald-400 font-semibold text-sm uppercase tracking-wider mb-3 block">
            Protection des données
          </span>
          <h1 className="text-4xl md:text-5xl font-bold text-white">Politique de confidentialité</h1>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4 max-w-3xl">
          <Block title="Responsable du traitement">
            <p>
              Le responsable du traitement des données collectées sur ce site est <strong>VIREO</strong>,
              29 rue Tronchet, 75008 Paris — devis@vireo-renovation.fr — 01 85 09 71 25.
            </p>
          </Block>

          <Block title="Données collectées">
            <p>Dans le cadre d'une demande de devis ou d'un dossier professionnel, nous collectons :</p>
            <ul className="list-disc pl-6 space-y-1">
              <li>votre nom et, le cas échéant, votre société / profession ;</li>
              <li>vos coordonnées (email, téléphone) ;</li>
              <li>la ville ou le secteur du projet ;</li>
              <li>les informations sur votre projet (type de travaux, budget, description) ;</li>
              <li>les pièces jointes que vous choisissez de transmettre (plans, photos, CCTP, DPGF…).</li>
            </ul>
          </Block>

          <Block title="Finalités et base légale">
            <p>
              Ces données sont utilisées uniquement pour traiter votre demande, établir un devis et
              vous recontacter. La base légale est l'exécution de mesures précontractuelles prises à
              votre demande, ainsi que votre consentement lors de l'envoi du formulaire.
            </p>
          </Block>

          <Block title="Destinataires">
            <p>
              Vos données sont destinées aux seules équipes de VIREO. Elles ne sont ni vendues, ni
              cédées à des tiers à des fins commerciales.
            </p>
          </Block>

          <Block title="Durée de conservation">
            <p>
              Les données sont conservées le temps nécessaire au traitement de votre demande puis,
              en cas de relation commerciale, pendant la durée légale applicable. À défaut de suite,
              elles sont supprimées dans un délai raisonnable.
            </p>
          </Block>

          <Block title="Vos droits">
            <p>
              Conformément au RGPD, vous disposez d'un droit d'accès, de rectification, d'effacement,
              de limitation et d'opposition sur vos données. Pour exercer ces droits, écrivez-nous à{' '}
              <a href="mailto:devis@vireo-renovation.fr" className="text-emerald-700 font-medium hover:underline">
                devis@vireo-renovation.fr
              </a>. Vous pouvez également introduire une réclamation auprès de la CNIL (www.cnil.fr).
            </p>
          </Block>

          <Block title="Cookies">
            <p>
              Ce site utilise uniquement les cookies strictement nécessaires à son fonctionnement
              (par exemple la session d'administration). Aucun cookie publicitaire de suivi tiers
              n'est déposé sans votre accord.
            </p>
          </Block>
        </div>
      </section>
    </main>
  );
};

export default PolitiqueConfidentialite;
